import request from '@/router/axios'

// 工地主任考勤确认调整
export const getList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/attendanceprojectsum/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

// 工地主任确认项目报表
export const downloadDirectorExam = params => request({
  url: '/api/mcc-worker/attendanceprojectsum/workerProjectSumExcel',
  method: 'get',
  params,
  responseType: 'blob',
})

export const getDetailList = (current, size, params) => request({
  url: '/api/mcc-worker/attendance/listDirDetail1',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

// 用于attendanceSummary页面的接口
export const getDetailList2 = (current, size, params) => request({
  url: '/api/mcc-worker/attendance/listDirDetail2',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const getDetailInfoList = (current, size, params) => request({
  url: '/api/mcc-worker/attendance/listDirDetail',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const updateAttendanceInfo = params => request({
  url: '/api/mcc-worker/attendance/update',
  method: 'post',
  data: params,
})

export const updateCheckTime = params => request({
  url: '/api/mcc-worker/attendance/update',
  method: 'post',
  data: params,
})

export const checkAttendance = params => request({
  url: '/api/mcc-worker/attendance/update2',
  method: 'post',
  data: params,
})

export const downloadTable = params => request({
  url: '/api/mcc-worker/attendance/export-notice1',
  method: 'get',
  responseType: 'blob',
})

export const uploadTable = (filename, file) => {
  const formData = new FormData()
  formData.append(filename, file)
  return request({
    url: '/api/mcc-worker/attendance/write-notice1',
    method: 'post',
    data: formData,
  })
}

export const downloadAttendance = params => request({
  // /mcc-worker/attendance/export-notice1112 去除bonus 导出
  url: '/api/mcc-worker/attendance/export',
  method: 'get',
  params,
  responseType: 'blob',
})

export const downloadAttendance1 = params => request({
  url: '/api/mcc-worker/attendance/exportBonus',
  method: 'get',
  params,
  responseType: 'blob',
})

export default {
  getList,
  downloadAttendance,
}
